__turbopack_context__.v({
  "pill": "_0H8HUW_pill",
});
